module.exports = __webpack_public_path__ + "img/noti-cross-2x.png?1c36cfb6cbc9106ce7e74be20225bd94";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/icons/noti-cross-2x.png
// module id = 311
// module chunks = 0